import React from 'react'

import QRCodeLoading from '../../../../../../assets/gif/qrcode.gif'
import Icon from '../../../../../../components/icon'
import { If } from '../../../../../../components/if/if'

import { Button } from '../styles'
import {
  Container,
  QRCodeWrapper,
  ActionsWrapper,
  DownloadButton,
  Overlay,
  Modal,
  Header,
} from './styles'

type IProps = {
  table: any | null;
  isOpen: any;
  onClose: () => void;
  onGenerate: (value: any) => void;
  isLoading: boolean;
}

const QRCodeModal = ({
  table, isOpen, onClose, onGenerate, isLoading,
}: IProps) => {
  const handleDownload = () => {
    window.open(table.qrcodeUrl)
  }

  return (
    <Overlay style={{ display: isOpen ? 'flex' : 'none' }}>
      <Modal>
        <Header>
          <h1>Gere um QR para a mesa</h1>
          <button type="button" onClick={onClose}>
            <Icon name="close" />
          </button>
        </Header>
        <Container>
          <If condition={table?.qrcodeUrl}>
            <QRCodeWrapper>
              <img src={table?.qrcodeUrl} alt="QRCode" />
            </QRCodeWrapper>
          </If>

          <If condition={!table?.qrcodeUrl}>
            <QRCodeWrapper>
              <img src={QRCodeLoading} alt="QRCode loading" />
            </QRCodeWrapper>
          </If>

          <ActionsWrapper>
            <If condition={table?.qrcodeUrl}>
              <DownloadButton onClick={handleDownload}>
                <Icon name="download" />
                Download
              </DownloadButton>
            </If>
            <Button onClick={() => onGenerate(table)} disabled={isLoading}>
              <Icon name="qrcode" />
              { isLoading ? 'Gerando...' : 'Clique para gerar o QR Code' }
            </Button>
          </ActionsWrapper>
        </Container>
      </Modal>
    </Overlay>
  )
}

export default QRCodeModal
